import { mapValues } from "lodash";

import editingUndoRedo, {
  shouldAutoEditItems as editingShouldAutoEditItems,
  undoRedoActionTypes as editingUndoRedoActionTypes,
  undoRedoOperations as editingUndoRedoOperations} from "./undoRedo.editing";
import readonlyUndoRedo from "./undoRedo.readonly";

let undoRedo = null;
let shouldAutoEditItems = () => false;
let undoRedoOperations = null;
let undoRedoActionTypes = {};
//#!if readonly !== true
// undoRedo = editingUndoRedo;
// shouldAutoEditItems = editingShouldAutoEditItems;
// undoRedoOperations = editingUndoRedoOperations;
// undoRedoActionTypes = editingUndoRedoActionTypes;
//#!else
undoRedo = readonlyUndoRedo;
undoRedoOperations = mapValues(editingUndoRedoOperations, _f => () => {});
//#!endif

export { shouldAutoEditItems, undoRedoActionTypes,undoRedoOperations };

export default undoRedo;
